import { afterRender, Component, Input } from '@angular/core';

@Component({
  selector: 'app-typeform',
  imports: [],
  templateUrl: './typeform.component.html',
  styleUrl: './typeform.component.scss',
})
export class TypeformComponent {
  @Input() typeformId!: string;
  @Input() _editable!: string;

  @Input() _uid!: string;
  @Input() component!: string;

  constructor() {
    afterRender(() => {
      const scriptUrl = 'https://embed.typeform.com/next/embed.js';

      if (!document.querySelector(`script[src="${scriptUrl}"]`)) {
        const s = document.createElement('script');
        s.src = scriptUrl;
        s.async = true;
        document.body.appendChild(s);
      }
    });
  }
}
